import { Component } from '@angular/core';

@Component({
  selector: 'app-historical-request',
  templateUrl: './historical-request.component.html',
  styleUrls: ['./historical-request.component.scss']
})
export class HistoricalRequestComponent {
	active=false;
	FuncionComponent(){
		if(this.active==false){
			this.active=true;
		}else{
			this.active=false
		}
	}
}
